import type { MarketingItemStoryblok } from '$types/bloks';

export const getNumberOfProductsToShowConsideringMarketingCards = (
  marketingItems: MarketingItemStoryblok[] = [],
  pageSize: number,
  pageCount: number,
  $region: string,
  $abTestVersion: string,
  $aboveLg: boolean,
  total?: number,
  hasNextPage?: boolean
): number | undefined => {
  // 1. Filter and sort relevant marketing items
  const filtered = marketingItems
    .filter(
      (item) =>
        item.regions?.includes($region) && (!item.ab_version || item.ab_version === $abTestVersion)
    )
    .sort((a, b) => {
      const aPos = $aboveLg ? a.desktop_position : a.mobile_position;
      const bPos = $aboveLg ? b.desktop_position : b.mobile_position;
      return Number(aPos) - Number(bPos);
    });

  if (filtered.length === 0) return undefined;

  // 2. Calculate total marketing size per page
  let pageIndex = 1;
  const pageSizeSums: number[] = [];
  filtered.forEach((item) => {
    const size = Number($aboveLg ? item.desktop_size : item.mobile_size);
    const position = Number($aboveLg ? item.desktop_position : item.mobile_position);
    if (position + size > pageSize * pageIndex) pageIndex += 1;
    pageSizeSums[pageIndex - 1] = (pageSizeSums[pageIndex - 1] || 0) + size;
  });

  // 3. Calculate remaining space per page
  const remainingSpacePerPage = pageSizeSums.map((sum) => pageSize - sum);

  // 4. Calculate cumulative remaining space per page
  let runningSum = 0;
  const cumulative = remainingSpacePerPage.map((value) => (runningSum += value));

  // 5. Calculate current cumulative remaining space for products
  const lastIndex = cumulative.length - 1;
  const last = cumulative?.[lastIndex] ?? 0;
  const current = cumulative?.[pageCount - 1];
  const lastPlusCurrent = last + (pageCount - 1 - lastIndex) * pageSize;
  const showAllProducts = !hasNextPage ? total : undefined;

  return showAllProducts ?? current ?? lastPlusCurrent;
};
